module.exports = __webpack_public_path__ + "9afbb12aba876198ee954db6ac941bb0.png";